import { z } from 'zod';
/**
 * Visitor languages (spec 2.9 "many kiosk languages"; docs/modules/languages.md). Owner: task I1 (structure), TR1
 * (translations). The portal stays English (UK); these are the languages visitors see on the kiosk, the contactless page,
 * public forms, the pre-arrival page and visitor emails. Tenant-written text (group names, questions, notices) is shown as
 * written.
 */
export const VISITOR_LOCALES = ['en-GB', 'fr', 'de', 'es', 'pl', 'ro', 'pt', 'it', 'cy', 'ar'];
export const VisitorLocale = z.enum(VISITOR_LOCALES);
export const VISITOR_LOCALE_INFO = {
    'en-GB': { endonym: 'English', dir: 'ltr' },
    fr: { endonym: 'Français', dir: 'ltr' },
    de: { endonym: 'Deutsch', dir: 'ltr' },
    es: { endonym: 'Español', dir: 'ltr' },
    pl: { endonym: 'Polski', dir: 'ltr' },
    ro: { endonym: 'Română', dir: 'ltr' },
    pt: { endonym: 'Português', dir: 'ltr' },
    it: { endonym: 'Italiano', dir: 'ltr' },
    cy: { endonym: 'Cymraeg', dir: 'ltr' },
    ar: { endonym: 'العربية', dir: 'rtl' },
};
/**
 * Message key prefixes visitors can see. Only these keys are translated (TR1); everything else falls back to en-GB.
 * I1 may extend this list (architect review); a meta test checks every visitor locale file uses only these prefixes
 * and keeps every `{placeholder}` of the English text.
 */
export const VISITOR_KEY_PREFIXES = [
    'kiosk.',
    'contactless.',
    'public.',
    'prearrival.',
    'forms.public.',
    'privacy.public.',
    'check.',
    'email.visitor.',
    'field.',
];
/** Site settings (core, I1): which languages the kiosk and contactless page offer, and the default. */
export const CoreSiteLanguageSettings = z.object({
    languages: z
        .object({
        defaultLanguage: VisitorLocale.default('en-GB'),
        /** Shown in the language picker; empty = no picker (default language only). */
        offered: z.array(VisitorLocale).max(10).default([]),
    })
        .default({ defaultLanguage: 'en-GB', offered: [] }),
});
/** Group settings (core, I1): a group may start the kiosk flow and its emails in another language (null = the site's). */
export const CoreGroupLanguageSettings = z.object({
    defaultLanguage: VisitorLocale.nullable().default(null),
});
/** Translation status per locale. 'draft' locales are offered only where the platform allows drafts (test server). */
export const LocaleStatus = z.enum(['draft', 'checked']);
//# sourceMappingURL=languages.js.map